export default __webpack_public_path__ + "static/supportBoxBg-999f8b2190c2a61657bcaede73ca0c00.png";